import axios from "axios";

const BOT_TOKEN = "8054664280:AAGVsheyzC9GHQhYukII4s-MSFzPFhMQ21o"; // Укажите токен бота
const IMAGE_API_URL = "https://xalavach.ru/api/image.php?file="; // API для получения изображения

export async function sendProductToTelegram(products, userId) {
  if (!userId) {
    console.error("❌ Ошибка: userId не передан или равен null");
    return;
  }

  console.log("📩 Отправка сообщений пользователю:", userId);

  for (const product of products) {
    // Формируем URL изображения
    const imageUrl = product.main_image ? `${IMAGE_API_URL}${product.main_image}` : null;

    // Формируем текст сообщения
    const message = `
<b>🔥 ${product.name}</b>
📌 Категория: <b>${product.category_name}</b>
📅 Действительно до: <b>${product.expiry_date || "Не указано"}</b>

📝 <i>${product.description}</i>

🎟 <b>Промокод:</b>
<blockquote><code>${product.promo_code}</code></blockquote>
`.trim();

    // Добавляем инлайн-кнопку, только если есть ссылка
    const replyMarkup = product.website_link
      ? JSON.stringify({
          inline_keyboard: [[{ text: "🌐 Открыть сайт", url: product.website_link }]],
        })
      : null;

    try {
      if (imageUrl) {
        console.log(`📷 Отправка изображения: ${imageUrl}`);

        await axios.post(`https://api.telegram.org/bot${BOT_TOKEN}/sendPhoto`, {
          chat_id: userId,
          photo: imageUrl,
          caption: message,
          parse_mode: "HTML",
          ...(replyMarkup ? { reply_markup: replyMarkup } : {}), // Добавляем reply_markup, только если он есть
        });

      } else {
        console.warn("⚠️ Нет изображения, отправляем только текст.");
        await axios.post(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
          chat_id: userId,
          text: message,
          parse_mode: "HTML",
          disable_web_page_preview: false,
          ...(replyMarkup ? { reply_markup: replyMarkup } : {}), // Добавляем reply_markup, только если он есть
        });
      }

      console.log(`✅ Сообщение отправлено пользователю ${userId}`);
    } catch (error) {
      console.error("❌ Ошибка при отправке в Telegram:", error.response?.data || error.message);
    }
  }
}
